export default "__VITE_ASSET__Cfgbtg2X__"